import React, { useState, useEffect } from "react";
import { format } from "date-fns";

function VisitList(props) {
  const [selectedDate, setSelectedDate] = useState();
  const [allVisitdates, setallVisitdates] = useState([]);

  useEffect(() => {
    console.log("------props in visit list---------", props);
    setSelectedDate(props.selectedDate);
    handleallVisitdates();
  }, [props]);

  const handleallVisitdates = () => {
    if (props.allVisitdates) {
      // Build a deduplicated list keyed by visit id (or fallback to id)
      const seen = new Map();
      for (const lastVisited of props.allVisitdates) {
        if (!lastVisited || lastVisited.internalStatus === "NotVisited" || !lastVisited.visitDate) continue;

        const visitId = lastVisited?.visit?.id ?? lastVisited?.visitId ?? lastVisited?.id;
        if (!visitId) {
          // fallback: include when no id present (rare)
          const key = JSON.stringify(lastVisited);
          if (!seen.has(key)) seen.set(key, lastVisited);
        } else {
          if (!seen.has(String(visitId))) seen.set(String(visitId), lastVisited);
        }
      }

      const vistdateLoop = Array.from(seen.values());
      setallVisitdates(vistdateLoop);
    }
    console.log("allVisitdates", allVisitdates);
  };

  const handleVisitSelect = (e) => {
    // setSelectedDate(e.target.value);
    // selectedDate = e.target.value
    console.log("handleVisitSelect", e);
    {
      props.handleVisitSelect
        ? props.handleVisitSelect(e)
        : props.handlevisitChange(e);
    }

    //    props.handlevisitChange(e);
  };

  const getFormateDate = (date, type) => {
    console.log(date);
    //  procedureDate = date;
    let formatedate;
    if (type === "discharge") {
      let date1 = date.split("T");
      formatedate = format(new Date(date1[0]), "MMM dd yyyy");
      console.log("discharge date", formatedate);
    } else {
      const reqdate = new Date(date);
      // const formatteddate = day + "/" + month + "/" + year + "   " +  hour+ ":" + min;
      formatedate = format(reqdate, "MMM dd yyyy");
    }
    return formatedate.toString();
  };

  return (
    <>
      <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 d-flex justify-content-end align-items-center">
        {/* <div className='col-6 d-flex align-items-center'> */}
        <span className="col-3">Select Date </span>
        <select
          name="Select Date"
          value={selectedDate}
          className="form-control VisitList"
          onChange={(e) => handleVisitSelect(e)}
        >
         {allVisitdates &&
  allVisitdates.map((lastVisited) => {
    if (!lastVisited?.visitDate) return null;

    const visitId =
      lastVisited?.visit?.id ??
      lastVisited?.visitId ??
      lastVisited?.id ??
      lastVisited?.lastvisitId;

    if (!visitId) return null;

    const date = getFormateDate(lastVisited.visitDate);
    const isInPatient = lastVisited.type === "InPatient";
    const visitTypeLabel = isInPatient ? "AD" : "VD";

    const ipopPart = lastVisited?.ipopnumber
      ? `${lastVisited.ipopnumber} ${visitTypeLabel} - `
      :`${visitTypeLabel} - `;

    const categoryLabel = lastVisited?.visitflag || lastVisited.type;

    const dischargePart =
      isInPatient && lastVisited?.dischargeDate
        ? ` - DD - ${getFormateDate(
            lastVisited.dischargeDate,
            "discharge"
          )}`
        : "";

    return (
      <option key={String(visitId)} value={String(visitId)}>
        {ipopPart}
        {date}
        {" - "}
        {categoryLabel}
        {dischargePart}
      </option>
    );
  })}
        </select>
        {/* </div> */}
      </div>
    </>
  );
}

export default VisitList;